import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
} from "../../../utils";

import {
  courseChapterBreadcrumbs,
  courseChaptersRoutesObj,
} from "@routes/facultyMember/courseManagement/courseChapter/path";

// Base route constant
const baseRoute = `${courseChaptersRoutesObj.view}/project` as const;

// * Route configuration object for courseChapterProjects-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const courseChapterProjectsRoutesObj = {
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:projectId`,
  edit: `${baseRoute}/edit/:projectId`,
} as const;

// ! these are breadcrumbs translation not page title
const courseChapterProjectsRouteTranslation: IRouteTranslation<
  typeof courseChapterProjectsRoutesObj
> = {
  create: "addProject",
  edit: "editProject",
  view: "viewProject",
};

// * Extracts the route parameters for the course-chapter-Projects route configuration.
export type ICourseChapterProjectsRouteParams = IExtractRouteParamMap<
  typeof courseChapterProjectsRoutesObj
>;

// * Path functions for the course-chapter-Projects routes.
export const courseChapterProjectsPath = createPaths<
  typeof courseChapterProjectsRoutesObj,
  ICourseChapterProjectsRouteParams
>(courseChapterProjectsRoutesObj);

// * Breadcrumbs {translation and route} for the course chapter Projects routes
const thisCourseChapterProjectsBreadcrumbs = createBreadcrumbObject<
  typeof courseChapterProjectsRoutesObj
>(courseChapterProjectsRoutesObj, courseChapterProjectsRouteTranslation);

export const courseChapterProjectsBreadcrumbs = concatBreadcrumbs<
  typeof courseChapterProjectsRoutesObj
>(courseChapterBreadcrumbs.view, thisCourseChapterProjectsBreadcrumbs);
